/* eslint max-len:0 */
import React from 'react'

function CloseIcon({ handleClose, style, className }) {
  return (
    <svg
      className={className}
      onClick={handleClose}
      viewBox="-1 -1 14 14"
      version="1.1"
      style={style}
    >
      <g strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(-947.000000, -121.000000)">
          <g transform="translate(948.000000, 121.000000)">
            <path d="M0,0 L11.3137085,11.3137085" />
            <path d="M11.3137085,0 L0,11.3137085" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CloseIcon
